import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-[#23242A] text-white h-screen appheader overflow-y-auto px-6 pt-6 pb-28" }
const _hoisted_2 = { class: "flex xl:flex-row flex-col bg-[#2B2C32] overflow-y-auto rounded-xl" }
const _hoisted_3 = { class: "w-full xl:w-1/2" }
const _hoisted_4 = { class: "w-full xl:w-1/2" }
const _hoisted_5 = {
  key: 1,
  class: "w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Info = _resolveComponent("Info", true)!
  const _component_StoreHours = _resolveComponent("StoreHours")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.vg_selectedLocation.id)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_Info)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_StoreHours)
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "bg-[#2B2C32] rounded-lg px-8 py-[16px]" }, [
              _createElementVNode("p", { class: "text-center text-theme-red" }, "Please select a location from the top left corner.")
            ], -1)
          ]))]))
    ])
  ]))
}